<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="addCount">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <a-avatar shape="square" icon="user" size="large" :class="$style.avatar" />
      </a-badge>
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <strong>Hola, {{user.email}}</strong>
        <div>
          {{user.email}}
        </div>
      </a-menu-item>
      <a-menu-divider />

      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i> Salir
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>

import store from '@/store'

export default {
  data: function () {
    return {
      count: 0,
      user: store.state.user.user,
    }
  },
  methods: {
    addCount() {
      // this.count++
    },
    logout() {
      this.$auth.logout()
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
